export const GENERAL = { id: 'general', label: 'In anestesia generale' };
export const EPIDURAL = { id: 'epidural', label: 'In anestesia epidurale' };
export const SPINAL = { id: 'spinal', label: 'In anestesia spinale' };
export const EPIDURAL_SPINAL = {
  id: 'epidural_spinal',
  label: 'In anestesia combinata epidurale/spinale',
};
